<template>
    <div class="form-group row" v-bind:class="{ 'has-danger' : form.errors.has(name) }">
        <label class="col-md-3 col-xl-2 col-sm-12 col-form-label">{{ label }}</label>
        <div class="col-md-9 col-xl-10 col-sm-12 radio-group">
            <!--<br/>-->
            <input required type="radio" id="one" value="1" v-model="form['active']">
            <label for="one">{{ uLang('app.yes') }}</label>
            <input required type="radio" id="two" value="0" v-model="form['active']">
            <label for="two">{{ uLang('app.no') }}</label>
            <br>
            <span class="help-block form-control-feedback" v-if="form.errors.has(name)" v-text="form.errors.get(name)"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'form-radio',

        props: {
            name: {
                type: String,
                required: true,
            },
            form: {
                required: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
            }
        },

        computed: {
            label: function () {
                return this.uLang('app.' + this.name) + (this.required ? ': *' : ': ');
            }
        }
    }
</script>

<style lang="css" scoped>
</style>